import React, { FC } from 'react';

import styled from '@emotion/styled';
import theme from '@vromo/ui/components/theme';
import { dataTestId } from '@vromo/models';



const Loader = styled.div`
    height: 6px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: hidden;

    &:before {
        display: block;
        position: absolute;
        content: '';
        left: -200px;
        width: 200px;
        height: 6px;
        border-radius: 10px;
        background-color: ${theme.primary};
        animation: loading 2s linear infinite;
    }

    @keyframes loading {
        from {
            left: -50%;
            width: 30%;
        }
        50% {
            width: 50%;
        }
        70% {
            width: 80%;
        }
        80% {
            left: 50%;
        }
        95% {
            left: 120%;
        }
        to {
            left: 150%;
        }
    }
`;




/** renders loading bar at the top of its container */
const PageLoader: FC<{ loading: boolean }> = ({ loading }) => loading ? <Loader data-testid={dataTestId.general.pageLoading} /> : null

export default PageLoader
